import { createStore } from "vuex";
import network from "./modules/network";
import feed from "./modules/feed";
import auth from "./modules/auth";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    network,
    feed,
    auth,
  },
});
